import { createTheme } from '@mui/material/styles';

import baseTheme from './base';
import button from './button';
import form from './form';
import input from './input';
// import table from './table';

const theme = createTheme(baseTheme, {
  components: {
    // ...layout(base),
    ...input,
    // ...select,
    ...button,
    // ...autocomplete,
    // ...list,
    ...form,
    // ...table,
    // ...menu,
    // ...alerts,
    // ...tabs,
    // ...toggles,
    // ...dialog,
    // ...pagination,
    // ...tooltip,
    // ...datagrid,
    // ...loader,
    // ...accordion,
    // ...link,
    // ...datePicker,
  },
});

export default theme;
